function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 0l1.625 4.798L13 4.952 9.16 8.048 10.488 13 6.5 10.214 2.364 13l1.33-4.952L0 4.952l4.727-.154z",
  fill: "#E5A837",
  fillRule: "nonzero"
})));